export enum StatusPlanologischEnum {
  ONHERROEPELIJK = '1A. Onherroepelijk',
  ONHERROEPELIJK_UITWERKINGSPLICHT = '1B. Onherroepelijk, uitwerkingsplicht',
  ONHERROEPELIJK_WIJZIGINGSBEVOEGDHEID = '1C. Onherroepelijk, wijzigingsbevoegdheid',
  VASTGESTELD = '2A. Vastgesteld',
  VASTGESTELD_UITWERKINGSPLICHT = '2B. Vastgesteld, uitwerkingsplicht',
  VASTGESTELD_WIJZIGINGSBEVOEGDHEID = '2C. Vastgesteld, wijzigingsbevoegdheid',
  IN_VOORBEREIDING = '3. In voorbereiding',
  VISIE = '4A. Visie',
  OPTIE = '4B. Optie',
  AMBTELIJK_MET_LOCATIE = '5A. Ambtelijk met locatie',
  AMBTELIJK_ZONDER_LOCATIE = '5B. Ambtelijk zonder locatie',
}
